import ViewBase from "../../../../framework/core/mvvm/view_base";
import AppData from "../../../public/const/app_data";

const { ccclass, property } = cc._decorator;

@ccclass
export default class CustomerView extends ViewBase {

    @property(cc.Button)
    closeBtn: cc.Button = null


    @property(cc.WebView)
    webView: cc.WebView = null

    start(){
        cc.log("webview start 1")
        var scheme = "appkey";
        function jsCallback(target, url) {
            var str = url.replace(scheme + '://', ''); // str === 'a=1&b=2'
            cc.log("webview,jscallback callback")
            // self.onKeyDown()
        }
        this.webView.setJavascriptInterfaceScheme(scheme);
        this.webView.setOnJSCallback(jsCallback);
    }
}
